import { SegmentedControl, SegmentedControlItem } from "@astryxdesign/core/SegmentedControl";
import { Monitor, Moon, Sun } from "lucide-react";
import type { ColorModePreference } from "../../lib/useColorMode";

interface ColorModeToggleProps {
  value: ColorModePreference;
  onChange: (mode: ColorModePreference) => void;
}

// A three-way exclusive choice (System/Light/Dark) is SegmentedControl, not
// TabList: it controls a persisted preference, not which view is on screen —
// see Astryx's own distinction between the two. Icon-only at "sm" so it sits
// quietly in the TopNav next to the live-camera count rather than competing
// with it for attention.
export function ColorModeToggle({ value, onChange }: ColorModeToggleProps) {
  return (
    <SegmentedControl value={value} onChange={(v) => onChange(v as ColorModePreference)} label="Color mode" size="sm">
      <SegmentedControlItem value="system" label="Match system" isLabelHidden icon={<Monitor size={14} />} />
      <SegmentedControlItem value="light" label="Light" isLabelHidden icon={<Sun size={14} />} />
      <SegmentedControlItem value="dark" label="Dark" isLabelHidden icon={<Moon size={14} />} />
    </SegmentedControl>
  );
}
